module.exports = __webpack_public_path__ + "order/img/donation.79b7a7c1.png";